function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MonotoneChainSelectAction from '../../index/chain/MonotoneChainSelectAction';
import MonotoneChain from '../../index/chain/MonotoneChain';
import ItemVisitor from '../../index/ItemVisitor';
var MCIndexPointSnapper = /*#__PURE__*/function () {
  function MCIndexPointSnapper() {
    _classCallCheck(this, MCIndexPointSnapper);
    MCIndexPointSnapper.constructor_.apply(this, arguments);
  }
  return _createClass(MCIndexPointSnapper, [{
    key: "snap",
    value: function snap() {
      if (arguments.length === 1) {
        var hotPixel = arguments[0];
        return this.snap(hotPixel, null, -1);
      } else if (arguments.length === 3) {
        var _hotPixel = arguments[0];
        var parentEdge = arguments[1];
        var hotPixelVertexIndex = arguments[2];
        var pixelEnv = _hotPixel.getSafeEnvelope();
        var hotPixelSnapAction = new HotPixelSnapAction(_hotPixel, parentEdge, hotPixelVertexIndex);
        this._index.query(pixelEnv, new (/*#__PURE__*/function () {
          function _class() {
            _classCallCheck(this, _class);
          }
          return _createClass(_class, [{
            key: "interfaces_",
            get: function get() {
              return [ItemVisitor];
            }
          }, {
            key: "visitItem",
            value: function visitItem(item) {
              var testChain = item;
              testChain.select(pixelEnv, hotPixelSnapAction);
            }
          }]);
        }())());
        return hotPixelSnapAction.isNodeAdded();
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MCIndexPointSnapper;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { MCIndexPointSnapper as default };
var HotPixelSnapAction = /*#__PURE__*/function (_MonotoneChainSelectA) {
  function HotPixelSnapAction() {
    var _this;
    _classCallCheck(this, HotPixelSnapAction);
    _this = _callSuper(this, HotPixelSnapAction);
    HotPixelSnapAction.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(HotPixelSnapAction, _MonotoneChainSelectA);
  return _createClass(HotPixelSnapAction, [{
    key: "isNodeAdded",
    value: function isNodeAdded() {
      return this._isNodeAdded;
    }
  }, {
    key: "select",
    value: function select() {
      if (arguments.length === 2 && Number.isInteger(arguments[1]) && arguments[0] instanceof MonotoneChain) {
        var mc = arguments[0];
        var startIndex = arguments[1];
        var ss = mc.getContext();
        if (this._parentEdge !== null) {
          if (ss === this._parentEdge && startIndex === this._hotPixelVertexIndex) return null;
        }
        this._isNodeAdded = this._hotPixel.addSnappedNode(ss, startIndex);
      } else return _superPropGet(HotPixelSnapAction, "select", this, 1).apply(this, arguments);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return HotPixelSnapAction;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(MonotoneChainSelectAction);
HotPixelSnapAction.constructor_ = function () {
  this._hotPixel = null;
  this._parentEdge = null;
  this._hotPixelVertexIndex = null;
  this._isNodeAdded = false;
  var hotPixel = arguments[0];
  var parentEdge = arguments[1];
  var hotPixelVertexIndex = arguments[2];
  this._hotPixel = hotPixel;
  this._parentEdge = parentEdge;
  this._hotPixelVertexIndex = hotPixelVertexIndex;
};
MCIndexPointSnapper.HotPixelSnapAction = HotPixelSnapAction;
MCIndexPointSnapper.constructor_ = function () {
  this._index = null;
  var index = arguments[0];
  this._index = index;
};